import { useSubscription } from "@/hooks/useSubscription";
import { openBillingPortal } from "@/lib/billing";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

/**
 * Red top-of-app banner shown when the latest subscription is in
 * `past_due` (Stripe failed to charge the card). NOT dismissible — the
 * user must update their payment method or risk losing access when
 * Stripe gives up retrying.
 */
export function PastDueBanner() {
  const { isPastDue } = useSubscription();
  if (!isPastDue) return null;

  return (
    <div className="w-full bg-destructive/10 border-b border-destructive/40 px-4 py-2 text-center text-xs text-destructive flex items-center justify-center gap-3">
      <AlertTriangle className="h-3.5 w-3.5" />
      <span>
        We couldn't charge your card. Update your payment method to keep your account active.
      </span>
      <Button
        variant="link"
        size="sm"
        className="h-auto p-0 text-xs text-destructive underline font-medium"
        onClick={() => void openBillingPortal()}
      >
        Update payment method
      </Button>
    </div>
  );
}
